import type { DetailedHTMLProps, FC, HTMLAttributes } from 'react'
import './styles.css'

type DivProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>

export const ContentContainer: FC<DivProps> = ({ children, ...htmlProps }) => (
  <div {...htmlProps} className="content-container">
    {children}
  </div>
)
